import React, { useState, forwardRef } from 'react';
import { RichTextEditor } from './components/RichTextEditor';
import { FieldRichTextEditorProps } from './types';
import {
  Label,
  HeaderContainer,
  ToggleWrapper,
  ModeToggleText,
  Textarea,
  TextEditorWrapper,
  ErrorText,
  Addons,
  RightAddons,
  Header,
  Root,
} from './styles';

const FieldRichTextEditor = forwardRef(
  (
    {
      name,
      onChange,
      value,
      error,
      isShowingError = !!error,
      label,
      placeholder,
      maxLength,
      className,
    }: FieldRichTextEditorProps,
    ref: React.Ref<HTMLTextAreaElement>
  ) => {
    const [isShowingRichTextEditor, setIsShowingRichTextEditor] = useState(
      true
    );

    const [isShowingFocusStyles, setisShowingFocusStyles] = useState(false);

    const onPressEditorModeToggle = () => {
      setIsShowingRichTextEditor(!isShowingRichTextEditor);
    };

    const toggleFocusStyles = () => {
      setisShowingFocusStyles(!isShowingFocusStyles);
    };

    return (
      <Root className={className}>
        <Label htmlFor={name}>
          <HeaderContainer>
            <Header>{label}</Header>
            <ToggleWrapper>
              <ModeToggleText onClick={onPressEditorModeToggle}>
                {isShowingRichTextEditor
                  ? 'Switch to HTML'
                  : 'Switch to rich text'}
              </ModeToggleText>
            </ToggleWrapper>
          </HeaderContainer>
        </Label>
        {isShowingRichTextEditor ? (
          <TextEditorWrapper
            isShowingError={isShowingError}
            isShowingFocusStyles={isShowingFocusStyles}
          >
            {/* TODO: Pass ref to this component once https://github.com/sstur/react-rte/pull/412
                or similar is merged */}
            <RichTextEditor
              onBlur={toggleFocusStyles}
              onFocus={toggleFocusStyles}
              maxCharacterLength={maxLength}
              onChange={onChange as (e: unknown) => void}
              placeholder={placeholder}
              value={value}
            />
          </TextEditorWrapper>
        ) : (
          <Textarea
            ref={ref}
            rows={15}
            name={name}
            onChange={onChange}
            placeholder="<p></p>"
            value={value}
          />
        )}
        <Addons>
          <ErrorText isShowingError={isShowingError}>
            {!!error && <span>{error.message}</span>}
          </ErrorText>
          {maxLength && (
            <RightAddons>
              {`${value?.toString().length || 0} / ${maxLength}`}
            </RightAddons>
          )}
        </Addons>
      </Root>
    );
  }
);

export { FieldRichTextEditor };
export { FieldRichTextEditorWithRedux } from './FieldRichTextEditorWithRedux';
